var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-derek"},[_c('div',{staticClass:"text-center"},[_c('img',{staticStyle:{"width":"60px","height":"60px"},attrs:{"src":require("@/assets/icons/load.gif"),"alt":""}})])])
}]

export { render, staticRenderFns }